import {
	getDateOnlyFromMomentToBEFormat,
	getDateOnlyStartOfDayFromBEDateString,
} from './DataFormatterUtils';

export const getApprovalTypesTracketOptions = (onlyCompletedWorkOrders) => [
	{
		value: 'WorkOrder',
		key: 'WorkOrder',
		title: 'Work Orders',
		children: [
			...(onlyCompletedWorkOrders
				? []
				: [
						{
							value: 'pending_workorders',
							key: 'pending_workorders',
							title: 'Pending',
							label: 'Work Order - Pending',
						},
				  ]),
			{
				value: 'approved_workorders',
				key: 'approved_workorders',
				title: 'Approved',
				label: 'Work Order - Approved',
			},
		],
	},
	{
		value: 'Quote',
		key: 'Quote',
		title: 'Quotes',
		children: [
			{
				value: 'pending_quotes',
				key: 'pending_quotes',
				title: 'Pending',
				label: 'Quote - Pending',
			},
			{
				value: 'approved_quotes',
				key: 'approved_quotes',
				title: 'Approved',
				label: 'Quote - Approved',
			},
		],
	},
	{
		value: 'Invoice',
		key: 'Invoice',
		title: 'Invoices',
		children: [
			{
				value: 'pending_invoices',
				key: 'pending_invoices',
				title: 'Pending',
				label: 'Invoice - Pending',
			},
		],
	},
];

export const transformBudgetAllCycles = (allCycles = []) =>
	allCycles.map((cycle, index) => {
		const [start, end] = (cycle && cycle.value) || [];
		return {
			cycle: index + 1,
			startDate: start ? getDateOnlyFromMomentToBEFormat(start) : null,
			endDate: end ? getDateOnlyFromMomentToBEFormat(end, true) : null,
		};
	});

export const getCycleRangeText = (cycle) => {
	if (!cycle.startDate || !cycle.endDate) return '';

	return `${getDateOnlyStartOfDayFromBEDateString(cycle.startDate).format(
		'DD MMM yyyy'
	)} - ${getDateOnlyStartOfDayFromBEDateString(cycle.endDate).format('DD MMM yyyy')}`;
};
